import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../lib/auth.js';
import { Loader2, ShieldOff } from 'lucide-react';
import { Link } from 'react-router-dom';

export function RouteGuard({ children }: { children: JSX.Element }): JSX.Element {
  const { user, loading, canAccessRoute } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center text-muted-foreground">
        <Loader2 className="h-6 w-6 animate-spin" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }

  if (!canAccessRoute(location.pathname)) {
    // Botão "Voltar" aponta pro landingRoute do user (não /, que pode também ser restrito).
    const safeTarget = user.landingRoute ?? '/';
    const landingLabel = safeTarget === '/meu-trabalho' ? 'Meu trabalho' : 'Dashboard';
    return (
      <div className="min-h-screen flex items-center justify-center px-6">
        <div className="max-w-md text-center space-y-4">
          <ShieldOff className="h-12 w-12 text-rose-400 mx-auto" />
          <h1 className="text-xl font-bold">Acesso restrito</h1>
          <p className="text-sm text-muted-foreground">
            Você não tem permissão para acessar <code className="text-foreground">{location.pathname}</code>.
            Se acha que é um erro, fale com o J. Lucas.
          </p>
          <Link
            to={safeTarget}
            className="inline-block px-4 py-2 rounded-md bg-primary text-primary-foreground text-sm font-medium hover:bg-primary/90"
          >
            Voltar pra {landingLabel}
          </Link>
        </div>
      </div>
    );
  }

  return children;
}
